import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DANHSACHTHANHLY } from "../actions/DanhSachThanhLy/actionTypes";
import {
  getListDanhSachThanhLySuccess,
  getListDanhSachThanhLyFailure,
} from "../actions/DanhSachThanhLy";
import DanhSachThanhLyApi from "../service/danhSachThanhLyApi";

function* getListDanhSachThanhLy(action) {
  try {
    const response = yield call(DanhSachThanhLyApi.list1, action.dataSearch);
    if (response.ok) {
      yield put(getListDanhSachThanhLySuccess(response.data));
    } else {
      yield put(getListDanhSachThanhLyFailure());
    }
  } catch (error) {
    yield put(getListDanhSachThanhLyFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHTHANHLY, getListDanhSachThanhLy);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
